import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var AdyenIssueIA = function AdyenIssueIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "bidl+1",
    defaultMessage: [{
      "type": 0,
      "value": "Pour résoudre les problèmes liés à Adyen, nous vous conseillons de contacter directement l'équipe d'assistance de la plateforme. Voici quelques points à vérifier avant de contacter l'assistance d'Adyen."
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "V5yO9f",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Configurez votre compte"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " : vous devez configurer votre compte Adyen dans les 6 semaines. Après ce délai, votre compte pourrait être suspendu temporairement."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "rrru2r",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Vérifiez votre compte :"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " assurez-vous que votre compte a été vérifié par Adyen. Vos paiements ne seront pas émis tant que votre compte bancaire n'aura pas été vérifié par Adyen."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "YOwZcP",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Fournissez les informations requises"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " : Adyen peut vous demander des informations supplémentaires à des fins de vérification, en particulier quand vous atteignez un certain chiffre d'affaires (1 000 £, 1 000 € ou 1 000 CHF). Veuillez fournir toutes les informations demandées."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 4
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "6dPuyj",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Vérifiez le type de compte"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " : confirmez que le type de compte (entreprise ou particulier) que vous avez sélectionné correspond à celui indiqué sur votre relevé bancaire. Il s'agit d'un critère essentiel pour la vérification de votre compte."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })))));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};